export default {
    maintenanceServicesToComplete_title: "Completar para ",
    maintenanceServicesToComplete_selectServiceComplete: "Seleccionar servicio a completar"
}